var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 14.0003V4.00033H5.5V14.0003H3.83333ZM7.16667 17.3337V0.666992H8.83333V17.3337H7.16667ZM0.5 10.667V7.33366H2.16667V10.667H0.5ZM10.5 14.0003V4.00033H12.1667V14.0003H10.5ZM13.8333 10.667V7.33366H15.5V10.667H13.8333Z",
    fill: "#40444D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIcon);
export default __webpack_public_path__ + "static/media/summary_icon.330b4db690563172169bb5ef1ac58351.svg";
export { ForwardRef as ReactComponent };